
import React from "react";
import { TableCell } from "@material-ui/core";
import styled from "styled-components";
import { DateTimeDisplay } from "core/Display";

const StyledTableCell = styled(TableCell)`
  vertical-align: top;
  font-size: 12px;
  line-height: 12px;
  min-width: 65px;
  max-width: 85px;
`;


export default function TableCellOrderType({ item }) {
  return (
    <StyledTableCell>
      {item.order_type && (
        <div
          style={{color: `${item.order_type.color}`, fontWeight: 'bold'}}
        >
          {item.order_type.short_name || item.order_type.name}
        </div>
      )}
      {item.station_arrival_date && (
        <div
          className={'mt-5'}
          style={{color: `${item.station_arrival_notify_date === null ? '#ff5722' : ''}`}}
        >
          <DateTimeDisplay value={item.station_arrival_date} format={'DD.MM'} />
        </div>
      )}
    </StyledTableCell>
  )
}
